import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "eclipse-timer-container",
  class: "info-overlay-container"
}
const _hoisted_2 = {
  key: 0,
  class: "eclipse-countdown"
}
const _hoisted_3 = {
  key: 0,
  class: "ec-timer"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = {
  key: 4,
  class: "eclipse-data-list"
}
const _hoisted_9 = { id: "eclipse-values" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { id: "time-container" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = { class: "time-value" }
const _hoisted_15 = {
  key: 0,
  class: "time"
}
const _hoisted_16 = { class: "time-value" }
const _hoisted_17 = { class: "time" }
const _hoisted_18 = { class: "time-value" }
const _hoisted_19 = {
  key: 1,
  class: "time"
}
const _hoisted_20 = { class: "time-value" }
const _hoisted_21 = { class: "time" }
const _hoisted_22 = { class: "time-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_define_term = _resolveComponent("define-term")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("h1", null, "Eclipse Timer", -1)),
    (_ctx.showTimer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.noEclipse)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.timeToShow), 1))
            : _createCommentVNode("", true),
          (!_ctx.noEclipse)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.timeText) + " " + _toDisplayString(_ctx.location !== '' ? 'at ' + _ctx.location : ''), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.noEclipse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("p", null, "No eclipse is predicted for this location.", -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.type) + " Eclipse", 1)
        ])),
    (!_ctx.noEclipse)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(['eclipse-icon', `eclipse-icon-${_ctx.type.toLowerCase()}`])
        }, null, 2))
      : _createCommentVNode("", true),
    (!_ctx.noEclipse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_define_term, {
                    term: "Max Eclipsed",
                    definition: "The fraction (percentage) of the Sun covered by the Moon.",
                    underlined: ""
                  }),
                  _cache[2] || (_cache[2] = _createTextVNode(": ", -1))
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.coveragePercent), 1)
              ]),
              (_ctx.isTotal)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _cache[3] || (_cache[3] = _createElementVNode("td", null, "Totality Duration:", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.totalityDuration), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.eclipseDuration != '')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _cache[4] || (_cache[4] = _createElementVNode("td", null, "Eclipse Duration:", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.eclipseDuration), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "eclipse-timer-dividier" }, null, -1)),
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", _hoisted_13, [
                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "time-label" }, "Partial Start", -1)),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.partialStart[1] === '' ? _ctx.timeString(_ctx.partialStart[0]) : 'Sun below Horizon'), 1)
              ]),
              (_ctx.isTotal)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _cache[6] || (_cache[6] = _createElementVNode("td", { class: "time-label" }, "Totality Start", -1)),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.centralStart[1] === '' ? _ctx.timeString(_ctx.centralStart[0]) : 'Sun below Horizon'), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", _hoisted_17, [
                _cache[7] || (_cache[7] = _createElementVNode("td", { class: "time-label" }, "Max Eclipse", -1)),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.maxTime[1] === '' ? _ctx.timeString(_ctx.maxTime[0]) : 'Sun below Horizon'), 1)
              ]),
              (_ctx.isTotal)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    _cache[8] || (_cache[8] = _createElementVNode("td", { class: "time-label" }, "Totality End", -1)),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.centralEnd[1] === '' ? _ctx.timeString(_ctx.centralEnd[0]) : 'Sun below Horizon'), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", _hoisted_21, [
                _cache[9] || (_cache[9] = _createElementVNode("td", { class: "time-label" }, "Partial End", -1)),
                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.partialEnd[1] === '' ? _ctx.timeString(_ctx.partialEnd[0]) : 'Sun below Horizon'), 1)
              ])
            ])
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("hr", {
            class: "mt-4",
            style: {"width":"100%"}
          }, null, -1))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_btn_toggle, {
      class: "mt-2",
      modelValue: _ctx.tzPref,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tzPref) = $event)),
      color: _ctx.color,
      divided: "",
      mandatory: "",
      "hide-details": "",
      variant: "outlined"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          value: "UTC",
          size: "small",
          height: "2em"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode("UTC", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          value: "Local",
          size: "small",
          height: "2em"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Local (" + _toDisplayString(_ctx.tzCode) + ")", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}